// src/pages/DashboardPage/DashboardPage.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import ExcursionsTab from "features/excursions/ExcursionsTab";
import ChalesTab from "features/chales/ChalesTab";
import { useUser } from "hooks/useUser";
import { usePendingAlerts } from "features/excursions/hooks/usePendingAlerts";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";

function DashboardPage() {
  const { role, canViewExcursions, canViewChales, canViewEstoque, canViewDashboard } = useUser();
  const { alerts } = usePendingAlerts(role);
  const location = useLocation();
  const stateDate = location.state?.date;
  const targetTab = location.state?.tab;

  const [searchTerm, setSearchTerm] = React.useState("");
  const [inputValue, setInputValue] = React.useState("");

  React.useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setSearchTerm(inputValue);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [inputValue]);

  // Se o usuário não tem acesso às duas abas principais de reserva da Home:
  if (!canViewExcursions && !canViewChales) {
      if (canViewEstoque) return <Navigate to="/estoque" replace />;
      if (canViewDashboard) return <Navigate to="/resumo" replace />;
      if (role === "admin") return <Navigate to="/admin" replace />;
      
      // Fallback amigável caso seja um usuário sem nenhuma permissão de visualização restando
      return (
        <div className="flex flex-col items-center justify-center h-[60vh] text-center px-4">
          <h2 className="text-2xl font-bold text-slate-800 dark:text-foreground">Bem-vindo ao Gestão Timbó</h2>
          <p className="mt-4 text-slate-600 dark:text-muted-foreground max-w-md">
            Você não possui permissões ativas para visualizar os recursos do sistema. 
            Por favor, solicite acesso a um administrador.
          </p>
        </div>
      );
  }

  const defaultTab = targetTab || (canViewExcursions
    ? "excursions"
    : "chales");

  return (
    <div className="w-full max-w-7xl mx-auto px-2 sm:px-4">
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Buscar por telefone..."
            className="border p-2 rounded w-64 text-foreground bg-background border-input"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </div>
      </div>

      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList>
          {canViewExcursions && (
            <TabsTrigger value="excursions" className="relative">
              Excursões
              {alerts && alerts.length > 0 && (
                <span className="ml-2 bg-orange-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full">
                  {alerts.length}
                </span>
              )}
            </TabsTrigger>
          )}

          {canViewChales && <TabsTrigger value="chales">Chalés</TabsTrigger>}
        </TabsList>

        {canViewExcursions && (
          <TabsContent value="excursions" className="mt-6">
            <ExcursionsTab userRole={role} searchTerm={searchTerm} />
          </TabsContent>
        )}

        {canViewChales && (
          <TabsContent value="chales" className="mt-6">
            <ChalesTab userRole={role} searchTerm={searchTerm} initialDate={stateDate} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}

export default DashboardPage;
